import { useMutation } from'@tanstack/react-query';
import { createTransferRequest } from'./api';
import { TransferRequestPayload } from'./types';

export const useCreateTransfer = () => {
 return useMutation({
 mutationFn: (data: TransferRequestPayload) => createTransferRequest(data),
 });
};

import { useSmartQuery } from "@shared/api/queries/hooks";
import { getConsumerMetaTransfer } from "./api";
import { ConsumerMetaTransferParams } from "./types";

export const useConsumerMetaTransfer = (params: ConsumerMetaTransferParams) => {
  return useSmartQuery(
    ["consumerWeb", "consumerMetaTransfer", params],
    () => getConsumerMetaTransfer(params),
    {
      enabled: !!params.consumer_id && !!params.remote_utility_id,
    }
  );
};
